@if (occurrence(); as occ) {
  <div class="npdc-title">
    <hgroup>
      <h1>{{ title() }}</h1>
      @if (occ.event) {
        <p>
          {{ occ.event | eventTitle }}
          / {{ occ.event.content.eventDate | slice: 0 : 10 }}
        </p>
      }
    </hgroup>
    <div class="npdc-title__actions">
      <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matTooltip="More actions">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </div>

  <mat-card class="npdc-leaflet" appearance="outlined">
    <app-leaflet-group [geometry]="geometry()"></app-leaflet-group>
  </mat-card>

  <app-plankton-propertylist
    [data]="occ.content"
    title="Occurrence data"
  ></app-plankton-propertylist>
  <app-plankton-propertylist
    [data]="occ.measurementsOrFacts"
    title="Occurrence measurementsOrFacts"
  ></app-plankton-propertylist>
  @if (occ.event) {
    <app-plankton-propertylist
      [data]="occ.event.content"
      title="Event data"
    ></app-plankton-propertylist>
    <app-plankton-propertylist
      [data]="occ.event.measurementsOrFacts"
      title="Event measurementsOrFacts"
    ></app-plankton-propertylist>
  }
  @if (occ.taxon) {
    <app-plankton-propertylist [data]="occ.taxon" title="Taxon"></app-plankton-propertylist>
  }

  <mat-menu #optionsMenu>
    <button mat-menu-item [routerLink]="['/plankton', 'event', occ.content.eventID]">
      <mat-icon>date_range</mat-icon> Show event
    </button>
    @if (occ.taxon) {
      <button mat-menu-item [routerLink]="['/plankton', 'taxon', occ.taxon.id]">
        <mat-icon>bubble_chart</mat-icon> Show taxon
      </button>
    }
    <a
      mat-menu-item
      href="{{ kinkoHost }}/plankton/occurrence/{{ occ.id }}?event=true"
      target="_blank"
    >
      <mat-icon>download</mat-icon> Download as JSON
    </a>
    @if (occ.content.scientificNameID) {
      <a mat-menu-item href="{{ occ.content.scientificNameID | wormsURL }}" target="_blank">
        <mat-icon>open_in_new</mat-icon> Show in WoRMS
      </a>
    }
    @if (authService.user(); as user) {
      @if (user.accessLevel === 'admin') {
        <button mat-menu-item [routerLink]="['/plankton', 'origin', occ.originID]">
          <mat-icon>info</mat-icon> Show origin
        </button>
        <a
          mat-menu-item
          href="{{ kinkoHost }}/plankton/occurrence/{{ occ.id }}?event=true&log=true"
          target="_blank"
        >
          <mat-icon>info</mat-icon> Show detailed JSON
        </a>
      }
    }
  </mat-menu>
}
